// =============================================================================
// domain/backtestContract.ts — a contract symbol reduced to its product. #58.
// -----------------------------------------------------------------------------
// Relocated from the old client's `bdContractRoot` (app/index.html:31673).
//
// ── ⚠ WHY A FOURTH ROOT STRIPPER, WHICH IS THE OBVIOUS OBJECTION ──
//
// This client already has three, and none of them handles what a BACKTEST
// symbol looks like:
//
//   `instrumentRoot`  (facets)      — root + month + year only. `[Sim]` and
//                                     `-CME` both defeat it, and its root is
//                                     capped at three characters.
//   `rootSymbol`      (commissions) — built for the fee table's key, not display
//   `cqgSymbolRoot`   (trade)       — the `F.US.` routing prefix only
//
// A backtest's contract is HAND-TYPED, so it carries whatever the trader pasted
// from their platform: a `[Sim]` tag, an exchange suffix, a CQG prefix, one- or
// two-digit years. The board's instrument filter has to group `MESU26` and
// `[Sim]ESU26-CME` by product or the filter offers the same product twice.
//
// ⚠ Unifying the four is a real cleanup and NOT this port's job. Doing it here
// would change the fee table's keys and the facet list's option set in a commit
// whose subject is a new tab. Noted, deliberately deferred.
// =============================================================================

/** Month codes, in the order the exchanges use them. */
const MONTH_CODES = 'FGHJKMNQUVXZ';

/**
 * `MESU26` → `MES` · `[Sim]ESU26-CME` → `ES` · `F.US.EPU26` → `EP`.
 *
 * Anything it cannot parse is returned as-is, uppercased and trimmed — an
 * unrecognised symbol is still a real product and must still be filterable.
 */
export function backtestContractRoot(sym: string | null | undefined): string {
  let s = String(sym ?? '').toUpperCase().trim();
  // A platform tag in brackets, then an exchange suffix.
  s = s.replace(/^\[[^\]]*\]/, '').replace(/-[A-Z]{2,}$/, '');
  // CQG's routing prefix.
  s = s.replace(/^F\.[A-Z0-9]+\./, '');
  // ⚠ 1 OR 2 digit years. Platforms disagree — `U6` and `U26` are the same
  // contract — and a stripper that only knows one leaves the other unmatched.
  const m = s.match(new RegExp(`^([A-Z0-9]+?)[${MONTH_CODES}]\\d{1,2}$`));
  return m?.[1] ?? s;
}
